import * as PropTypes from "prop-types"
import React, {Component} from "react"
import {Button, Input, Popup} from "semantic-ui-react"

import shop from "shop/shop"


const showWarningToast = msg => {
	shop.toast( msg, "warning", false, "bottom" )
}


class ProductCount extends Component {

	render() {
		let {product, onChange, list} = this.props
		let showVEWarning = shop.config.checkout.limitToStock && (product.count >= Math.floor( product.stock / product.unit_multi ))
		let showVEWarningMin = product.pinfos.minbuy && product.count <= product.pinfos.minbuy
		//console.log("PRODUCT COUNT: ", product, showVEWarningMin)

		return (
			<Input min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1}
				defaultValue={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : product.count}
				onChange={( e ) => {
					if( !e.target.value || e.target.value === "0" ) {
						console.log("ProductCount: No value entered, setting count to 1")
						product.count = 1
						return onChange( {product, count: 1} )
					}
					let count = Math.round( e.target.value)
					showVEWarningMin = product.pinfos.minbuy && count <= product.pinfos.minbuy

					const mengenMulti = product.extras && product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);
					let newValue = e.target.value;

					if (mengenMulti && mengenMulti > 0 && (newValue > mengenMulti)) {
						const candidate = newValue - 1 + mengenMulti;
						const candidate2 = Number(Number(newValue) + 1 - Number(mengenMulti));
						if (candidate % mengenMulti === 0) {
							newValue = candidate;
						} else if (candidate2 % mengenMulti === 0) {
							newValue = candidate2;
						} else {
							return;
						}
					}
					if (mengenMulti && mengenMulti > 0) {
						if (e.nativeEvent.inputType === "insertText" || e.nativeEvent.inputType === "deleteContentBackward") {
							return;
						}
						let parsed = parseInt(newValue, 10);
						if (isNaN(parsed) || parsed % mengenMulti !== 0) {
							parsed = Math.floor(parsed / mengenMulti) * mengenMulti;
							return;
						}
					}
					if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
						e.target.value = Number(product.pinfos.minbuy)
						showWarningToast( "Mindestbestellmenge wurde korrigiert." )
					}
					product.count = Number( newValue )
					if(list){
						setTimeout(() => onChange( {product, count: newValue} ), 1000)
					}
					else{
						onChange( {product, count: newValue} )
					}
					
				}}
				className="text-center"
				type="number"
				placeholder="0"
				action>
				<input value={product.count } tabIndex={99} style={{minWidth: "60px", maxWidth: "70px"}} />
				<Button
					size="tiny"
					icon="minus"
					onClick={() => {
						if (shop.config.checkout.limitToStock) {
							product.count = Math.min(product.count, Math.floor(product.stock / product.unit_multi));
						}

						const mengenMulti = product.extras && product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);

						let newCount = product.count - 1;

						if (mengenMulti && mengenMulti > 0) {
							const minBuy = Number(product.pinfos.minbuy) || 1;
							// Decrease by mengenMulti, but not below minBuy
							newCount = product.count - mengenMulti;
							if (newCount < minBuy) {
								newCount = minBuy;
							}
							// Ensure newCount is a multiple of mengenMulti
							if (newCount % mengenMulti !== 0) {
								newCount = Math.floor(newCount / mengenMulti) * mengenMulti;
								if (newCount < minBuy) {
									newCount = minBuy;
								}
							}
						}

						if (product.onChange) {
							let ok = product.onChange({ count: newCount });
							if (!ok) {
								showWarningToast("Maximale Abnahmemenge erreicht");
								return false;
							}
							if (showVEWarningMin) {
								showWarningToast("Mindestabnahmemenge erreicht");
								return false;
							}
						}

						product.count = Math.max(newCount, 0);
						onChange({ product });
					}} />
				<Button
					size="tiny"
					icon="plus"
					onClick={() => {
						if (shop.config.checkout.limitToStock) {
							product.count = Math.min(product.count, Math.floor(product.stock / product.unit_multi));
						}

						const mengenMulti = product.extras && product.extras.mengenMulti && product.extras.mengenMulti.value && Number(product.extras.mengenMulti.value.value);

						let newCount;
						if (mengenMulti && mengenMulti > 0) {
							const minBuy = Number(product.pinfos.minbuy) || 1;
							// Increase by mengenMulti, but not below minBuy
							newCount = product.count + mengenMulti;
							if (newCount < minBuy) {
								newCount = minBuy;
							}
							// Ensure newCount is a multiple of mengenMulti
							if (newCount % mengenMulti !== 0) {
								newCount = Math.ceil(newCount / mengenMulti) * mengenMulti;
								if (newCount < minBuy) {
									newCount = minBuy;
								}
							}
						} else {
							newCount = product.count + 1;
						}

						if (product.onChange) {
							let ok = product.onChange({ count: newCount });
							if (!ok) {
								showWarningToast("Maximale Abnahmemenge erreicht");
								return false;
							}
						}
						product.count = newCount;
						onChange({ product });
					}} />
				{showVEWarning &&
				<Popup trigger={<Button circular icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager" />}
					   content="Keine weiteren Artikel auf Lager" />}
			</Input>)
	}
}

ProductCount.propTypes = {
	product : PropTypes.any,
	onChange: PropTypes.any
}


export default ProductCount



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductCount.js